import { render, staticRenderFns } from "./sxspzjcljds.vue?vue&type=template&id=3dde4667&scoped=true&"
import script from "./sxspzjcljds.vue?vue&type=script&lang=js&"
export * from "./sxspzjcljds.vue?vue&type=script&lang=js&"
import style0 from "./sxspzjcljds.vue?vue&type=style&index=0&id=3dde4667&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dde4667",
  null
  
)

export default component.exports